module.exports = __webpack_public_path__ + "img/marketplace_icon.f11b4df0.svg";